var module;
// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['i18next', 'i18next-chained-backend', 'i18next-browser-languagedetector', 'react-i18next'], (i18n, backend, browser_langdetector, react_i18n) => {
  var inited = false;
  var i18n_init = (backends, backendOptions, opt = {}, init_prop) => {
    // XXX dmitriiz: webpack fix
    if (i18n && i18n.default) i18n = i18n.default;
    if (browser_langdetector && browser_langdetector.default) browser_langdetector = browser_langdetector.default;
    if (backend && backend.default) backend = backend.default;
    if (inited) return i18n;
    var ns = opt.ns || [];
    var resources = init_prop && init_prop.i18n_store || undefined;
    var init_process = i18n.use(browser_langdetector).use(backend).use(react_i18n.initReactI18next).init({
      whitelist: ['en', 'ru', 'es', 'tr', 'de', 'ja', 'fr', 'he'],
      fallbackLng: 'en',
      preload: ['en'],
      ns: ['translation', ...ns],
      defaultNS: 'translation',
      debug: opt.debug,
      interpolation: {
        escapeValue: false
      },
      backend: {
        backends,
        backendOptions
      },
      detection: {
        caches: [],
        lookupQuerystring: 'lang',
        order: ['querystring']
      },
      react: {
        useSuspense: false
      },
      resources
    });
    inited = true;
    i18n._init_process = init_process;
    return i18n;
  };
  return i18n_init;
});